import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filters: {
    supplierId: null,
    supplierName: '',
    fromDate: null,
    toDate: null,
    rawFrom: null,
    rawTo: null,
  },
  list: [],
  loading: false,
  openingBalance: 0,
  closingBalance: 0,
  selectedSupplier: null,
  searchResults: [],
  loadingSearch: false,
  // ── linked customer ──────────────────────────
  linkedParty: null,
  customerLedgerList: [],
  customerOpeningBalance: 0,
  customerClosingBalance: 0,
};

const supplierLedgerSlice = createSlice({
  name: 'supplierLedger',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setLedgerData: (state, action) => {
      state.list             = action.payload.ledger || [];
      state.openingBalance   = action.payload.opening_balance || 0;
      state.closingBalance   = action.payload.closing_balance || 0;
      state.selectedSupplier = action.payload.supplier || null;

      // ── linked customer data ──────────────────
      const lp = action.payload.linked_party;
      state.linkedParty            = lp || null;
      state.customerLedgerList     = lp?.ledger            || [];
      state.customerOpeningBalance = lp?.opening_balance   || 0;
      state.customerClosingBalance = lp?.closing_balance   || 0;
    },
    setSearchResults: (state, action) => {
      state.searchResults = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setLoadingSearch: (state, action) => {
      state.loadingSearch = action.payload;
    },
    resetState: () => initialState,
  },
});

export const {
  setFilters, setLedgerData, setSearchResults,
  setLoading, setLoadingSearch, resetState,
} = supplierLedgerSlice.actions;
export default supplierLedgerSlice.reducer;